import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA } from '@angular/core';
import { AuthGuard } from '../auth.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Route, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSummernoteModule } from 'ngx-summernote';
import { ReviewVetProfilePopupComponent } from './review-vet-profile-popup/review-vet-profile-popup.component';
import { SalesCompanyProfileComponent } from './sales-company-profile/sales-company-profile.component';
import { VetProfileComponent } from './vet-profile/vet-profile.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { SaleCompanyAdminRoleGuard } from '../sale-company-admin-role.gaurd';
import { VetAdminRoleGuard } from '../vet-admin-role.gaurd';

import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

import { VetUserProfileComponent } from './vet-user-profile/vet-user-profile.component';
import { MatTabsModule } from '@angular/material/tabs';
import { SettingsModule } from '../settings/settings.module';
import { ReviewProfileInfoComponent } from './review-profile-info/review-profile-info.component';
import { VetProfileNotificationDetailPopupComponent } from './vet-profile-notification-detail-popup/vet-profile-notification-detail-popup.component';
import { SalesModule } from '../sales/sale-index.module';
import { NotificationTemplateModule } from '../shared/notification-template/notification-template.module';

const routes: Route[] = [
  {
    path: 'vet',
    component: VetProfileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'user',
    component: VetUserProfileComponent,
  },
  {
    path: 'sales-company',
    component: SalesCompanyProfileComponent,
    canActivate: [AuthGuard]
  },
];

@NgModule({
  declarations: [
    UserProfileComponent,
    VetProfileComponent,
    SalesCompanyProfileComponent,
    ReviewVetProfilePopupComponent,
    VetUserProfileComponent,
    ReviewProfileInfoComponent,
    VetProfileNotificationDetailPopupComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    RouterModule,
    MatCheckboxModule,
    MatFormFieldModule,
    NgxSummernoteModule,
    NgxIntlTelInputModule,
    MatTabsModule,
    SettingsModule,
    SalesModule,
    NotificationTemplateModule

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [],
})
export class ProfilePageModule {}
